import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-faacdd60"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "provision_title" }, "利用規約", -1))
const _hoisted_2 = { class: "provision_layout" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"provision_layout_title\" data-v-faacdd60><span class=\"provision_layout_title_text\" data-v-faacdd60>転職支援サービス利用規約</span><span class=\"provision_layout_title_required\" data-v-faacdd60>必須</span></div><div class=\"provision_layout_content\" data-v-faacdd60><p class=\"provision_layout_content_text\" data-v-faacdd60> 私は、マスメディアンの転職支援サービスを利用するにあたり、ホームページに記載されている利用規約を読了のうえこれに同意いたします。 </p><div class=\"provision_layout_content_link\" data-v-faacdd60><a href=\"https://www.massmedian.co.jp/privacy/provision.html\" target=\"_blank\" class=\"text_link\" data-v-faacdd60>利用規約の詳細はこちら ＞</a></div></div>", 2)
const _hoisted_5 = { class: "provision_layout_agree" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "provision_layout_annotation" }, "同意いただけない場合は当社転職支援サービスをご利用いただけません。ご了承ください。", -1))
const _hoisted_7 = { class: "provision_layout" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"provision_layout_title\" data-v-faacdd60><span class=\"provision_layout_title_text\" data-v-faacdd60>個人情報の取り扱いについて</span><span class=\"provision_layout_title_required\" data-v-faacdd60>必須</span></div><div class=\"provision_layout_content\" data-v-faacdd60><p class=\"provision_layout_content_text\" data-v-faacdd60> 私は、ホームページに記載されている個人情報の取り扱いについての規約を読了のうえこれに同意いたします。 </p><div class=\"provision_layout_content_link\" data-v-faacdd60><a href=\"https://www.massmedian.co.jp/privacy/\" target=\"_blank\" class=\"text_link\" data-v-faacdd60>個人情報規約の詳細はこちら ＞</a></div></div>", 2)
const _hoisted_10 = { class: "provision_layout_agree" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "provision_layout_annotation" }, "同意いただけない場合は当社転職支援サービスをご利用いただけません。ご了承ください。", -1))
const _hoisted_12 = { class: "provision_layout" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"provision_layout_title\" data-v-faacdd60><span class=\"provision_layout_title_text\" data-v-faacdd60>取扱職種の範囲等について</span><span class=\"provision_layout_title_required\" data-v-faacdd60>必須</span></div><div class=\"provision_layout_content\" data-v-faacdd60><p class=\"provision_layout_content_text\" data-v-faacdd60> 私は、取扱職種の範囲等について確認したことを誓約いたします。 </p><div class=\"provision_layout_content_link\" data-v-faacdd60><a href=\"https://files.massmedian.co.jp/data/meiji.pdf\" target=\"_blank\" class=\"text_link\" data-v-faacdd60>取扱職種の範囲等の詳細はこちら ＞</a></div></div>", 2)
const _hoisted_15 = { class: "provision_layout_agree" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "provision_layout_annotation" }, "同意いただけない場合は当社転職支援サービスをご利用いただけません。ご了承ください。", -1))
const _hoisted_17 = { class: "provision_layout" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"provision_layout_title\" data-v-faacdd60><span class=\"provision_layout_title_text\" data-v-faacdd60>入力情報・作成書類について</span><span class=\"provision_layout_title_required\" data-v-faacdd60>必須</span></div><div class=\"provision_layout_content\" data-v-faacdd60><p class=\"provision_layout_content_text\" data-v-faacdd60> 私は、自身でホームページから入力したキャリアシートの情報と自身で作成した履歴書・職務経歴書・作品等の内容に関して、虚偽・誇張がないことを誓約します。 </p></div>", 2)
const _hoisted_20 = { class: "provision_layout_agree" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "provision_layout_annotation" }, "同意いただけない場合は当社転職支援サービスをご利用いただけません。ご了承ください。", -1))
const _hoisted_22 = { class: "provision_layout" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "provision_layout_title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "登録データの開示について"),
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_required" }, "必須")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "provision_layout_content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "provision_layout_content_text" }, " 私は、自身を特定できる項目（氏名、生年月日、住所、電話番号、メールアドレス）を伏せた状態での登録データを、書類選考の機会を広げる為に企業へ公開されることに関して同意します。 ")
], -1))
const _hoisted_25 = { class: "provision_layout_disclosure" }
const _hoisted_26 = { class: "provision_layout_disclosure_radio" }
const _hoisted_27 = {
  class: "radio",
  for: "disclosure_1"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "radio_text" }, "はい", -1))
const _hoisted_29 = { class: "provision_layout_disclosure_radio" }
const _hoisted_30 = {
  class: "radio",
  for: "disclosure_2"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "radio_text" }, "いいえ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "provision_layout_annotation" }, "「いいえ」を選択された場合、登録データを許諾なしに開示しません。", -1))
const _hoisted_33 = {
  key: 0,
  class: "provision_layout"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "provision_layout_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_text" }, "転職希望時期について"),
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_required" }, "必須")
], -1))
const _hoisted_35 = { class: "provision_input" }
const _hoisted_36 = { class: "provision_layout" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "provision_layout_title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "企業との面接日時について"),
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_optional" }, "任意")
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "provision_layout_content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "provision_layout_content_text" }, " 企業面接は平日の日中（10:00～19:00）に行われることが一般的です。調整が難しい特定の日時や、時間帯がある場合は、事前に教えてください。 ")
], -1))
const _hoisted_39 = { class: "provision_layout_textarea" }
const _hoisted_40 = { class: "provision_layout" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "provision_layout_title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "マスメディアンからのご連絡について"),
  /*#__PURE__*/_createElementVNode("span", { class: "provision_layout_title_optional" }, "任意")
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "provision_layout_content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "provision_layout_content_text" }, " 転職活動を迅速に進めていくうえで、ご登録いただいている携帯電話に日中ご連絡をさせていただく場合がございます。マスメディアンからのお電話でのご連絡について、特別な注意が必要な場合には、ご記載ください。 ")
], -1))
const _hoisted_43 = { class: "provision_layout_textarea" }
const _hoisted_44 = { class: "provision_button" }

import BaseButton from '@/components/BaseButton.vue';
import BaseTextareaForm from '@/components/BaseTextareaForm.vue';
import BaseCheckboxNoBorder from '@/components/BaseCheckboxNoBorder.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import { useField, useForm } from 'vee-validate';
import { validationRuleHelper } from '@/utils/validationRule';
import { PropType, onBeforeMount, ref } from 'vue';
import { useStore } from 'vuex';
import BaseSelectBox, { Options } from '@/components/BaseSelectBox.vue';
import { getMasterWishJobChangeDateId } from '@/api/masterDataEndpoint';
import type { MasterWishJobChangeDateId } from '@/api/masterDataEndpoint';
import { object, string, number } from 'yup';
import { computed } from 'vue'; 

type Provision = {
  consentFlg1?: boolean;
  consentFlg2?: boolean;
  consentFlg3?: boolean;
  consentFlg4?: boolean;
  lastChargeFlg?: boolean;
  aboutDateInterview?: string;
  aboutCommunicationMedia?: string;
  wishJobChangeDateId?: number;
  wishJobChangeDateDisplayFlg?: boolean;
};

type ChangeDateConvert = {
  value: number;
  label: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Provision',
  props: {
  provision: {
    type: Object as PropType<Provision>,
    required: true,
  },
},
  emits: ["submit"],
  setup(__props, { emit: emits }: { emit: ({ (e: 'submit', value: Provision): void }), expose: any, slots: any, attrs: any }) {

const props = __props


const store = useStore();



const { meta, errors, values } = useForm<Provision>();
const { value: consentFlg1 } = useField<boolean>('consentFlg1', validationRuleHelper({ requiredAndTrue: true }), {
  initialValue: props.provision.consentFlg1,
  bails: false,
});
const { value: consentFlg2 } = useField<boolean>('consentFlg2', validationRuleHelper({ requiredAndTrue: true }), {
  initialValue: props.provision.consentFlg2,
  bails: false,
});
const { value: consentFlg3 } = useField<boolean>('consentFlg3', validationRuleHelper({ requiredAndTrue: true }), {
  initialValue: props.provision.consentFlg3,
  bails: false,
});
const { value: consentFlg4 } = useField<boolean>('consentFlg4', validationRuleHelper({ requiredAndTrue: true }), {
  initialValue: props.provision.consentFlg4,
  bails: false,
});
const { value: lastChargeFlg } = useField<boolean>('lastChargeFlg', validationRuleHelper({ required: true }), {
  initialValue: props.provision.lastChargeFlg,
  bails: false,
});
const { value: aboutDateInterview } = useField<string>('aboutDateInterview', validationRuleHelper({ max: 1000 }), {
  initialValue: props.provision.aboutDateInterview || '',
  bails: false,
  label: '企業との面接日時について',
});
const { value: aboutCommunicationMedia } = useField<string>('aboutCommunicationMedia', validationRuleHelper({ max: 1000 }), {
  initialValue: props.provision.aboutCommunicationMedia || '',
  bails: false,
  label: 'マスメディアンからのご連絡について',
});

const { value: wishJobChangeDateId } = useField<number>('wishJobChangeDateId', validationRuleHelper({ required: props.provision.wishJobChangeDateDisplayFlg === true }), {
  initialValue: props.provision.wishJobChangeDateId,
  bails: false,
});


const changeDateConvert = computed<ChangeDateConvert[]>(() =>
  (masterWishJobChangeDateList.value ?? []).map((item) => ({
    value: String(item.code),
    label: item.name,
  }))
);
const masterWishJobChangeDateList = ref<MasterWishJobChangeDateId[]>([]);

onBeforeMount(async () => {
  masterWishJobChangeDateList.value = await getMasterWishJobChangeDateId();
  wishJobChangeDateId.value = props.provision.wishJobChangeDateId ?? '';
});

const submit = async () => {

  store.commit('provision/set', {
    ...values,
    changeDateConvert: changeDateConvert.value,
  });

  emits('submit', {
    provision: {
      consentFlg1: consentFlg1.value,
      consentFlg2: consentFlg2.value,
      consentFlg3: consentFlg3.value,
      consentFlg4: consentFlg4.value,
      lastChargeFlg: lastChargeFlg.value,
      aboutDateInterview: aboutDateInterview.value,
      aboutCommunicationMedia: aboutCommunicationMedia.value,
      wishJobChangeDateId: wishJobChangeDateId.value,
      wishJobChangeDateDisplayFlg: props.provision.wishJobChangeDateDisplayFlg,
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(BaseCheckboxNoBorder, {
          name: "consentFlg1",
          label: "同意する",
          modelValue: _unref(consentFlg1),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(consentFlg1) ? (consentFlg1).value = $event : null)),
          value: _unref(consentFlg1)
        }, null, 8, ["modelValue", "value"])
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(BaseCheckboxNoBorder, {
          name: "consentFlg2",
          label: "同意する",
          modelValue: _unref(consentFlg2),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(consentFlg2) ? (consentFlg2).value = $event : null)),
          value: _unref(consentFlg2)
        }, null, 8, ["modelValue", "value"])
      ]),
      _hoisted_11
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_15, [
        _createVNode(BaseCheckboxNoBorder, {
          name: "consentFlg4",
          label: "同意する",
          modelValue: _unref(consentFlg4),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(consentFlg4) ? (consentFlg4).value = $event : null)),
          value: _unref(consentFlg4)
        }, null, 8, ["modelValue", "value"])
      ]),
      _hoisted_16
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_20, [
        _createVNode(BaseCheckboxNoBorder, {
          name: "consentFlg3",
          label: "同意する",
          modelValue: _unref(consentFlg3),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(consentFlg3) ? (consentFlg3).value = $event : null)),
          value: _unref(consentFlg3)
        }, null, 8, ["modelValue", "value"])
      ]),
      _hoisted_21
    ]),
    _createElementVNode("div", _hoisted_22, [
      _hoisted_23,
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("label", _hoisted_27, [
            _withDirectives(_createElementVNode("input", {
              class: "radio_input",
              id: "disclosure_1",
              type: "radio",
              name: "lastChargeFlg",
              value: true,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(lastChargeFlg) ? (lastChargeFlg).value = $event : null))
            }, null, 512), [
              [_vModelRadio, _unref(lastChargeFlg)]
            ]),
            _hoisted_28
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("label", _hoisted_30, [
            _withDirectives(_createElementVNode("input", {
              class: "radio_input",
              id: "disclosure_2",
              type: "radio",
              name: "lastChargeFlg",
              value: false,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(lastChargeFlg) ? (lastChargeFlg).value = $event : null))
            }, null, 512), [
              [_vModelRadio, _unref(lastChargeFlg)]
            ]),
            _hoisted_31
          ])
        ])
      ]),
      _hoisted_32
    ]),
    (props.provision.wishJobChangeDateDisplayFlg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createVNode(BaseSelectBox, {
              modelValue: _unref(wishJobChangeDateId),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(wishJobChangeDateId) ? (wishJobChangeDateId).value = $event : null)),
              name: "changeDate",
              options: _unref(changeDateConvert),
              placeholder: "転職希望時期を選択"
            }, null, 8, ["modelValue", "options"])
          ]),
          (_unref(errors).aboutDateInterview)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: [_unref(errors).aboutDateInterview]
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_36, [
      _hoisted_37,
      _hoisted_38,
      _createElementVNode("div", _hoisted_39, [
        _createVNode(BaseTextareaForm, {
          name: "",
          rows: 3,
          maxCount: 1000,
          placeholder: "例：月曜日以外",
          modelValue: _unref(aboutDateInterview),
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(aboutDateInterview) ? (aboutDateInterview).value = $event : null))
        }, null, 8, ["modelValue"])
      ]),
      (_unref(errors).aboutDateInterview)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            errors: [_unref(errors).aboutDateInterview]
          }, null, 8, ["errors"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_40, [
      _hoisted_41,
      _hoisted_42,
      _createElementVNode("div", _hoisted_43, [
        _createVNode(BaseTextareaForm, {
          name: "",
          rows: 3,
          "max-count": 1000,
          placeholder: "例：平日10:00〜18:00にお願いします",
          modelValue: _unref(aboutCommunicationMedia),
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(aboutCommunicationMedia) ? (aboutCommunicationMedia).value = $event : null))
        }, null, 8, ["modelValue"])
      ]),
      (_unref(errors).aboutCommunicationMedia)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            errors: [_unref(errors).aboutCommunicationMedia]
          }, null, 8, ["errors"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createVNode(BaseButton, {
        disabled: !_unref(meta).valid,
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode("確認画面へ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ], 64))
}
}

})